import Fuse from 'fuse.js';

//const prefix = 'http://localhost:8012';
const prefix = window.location.protocol + '//' + window.location.host;

// Debounced function to limit API calls during typing
const debounce = (fn, delay) => {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, arguments), delay);
  };
}; 

function replaceWordsWithSpan(text, words) {
  // Create a regex pattern that matches both singular and plural forms
  const regex = new RegExp(`\\b(${words.join('|')})s?\\b`, 'gi');
  return text.replace(regex, (match) => `<b>${match}</b>`);
}

const searchWp = async (text) => {
  // Include both singular and plural forms in the search query
  const singularText = text.replace(/s$/, '');
  const pluralText = text.endsWith('s') ? text : `${text}s`;
  const searchQuery = `${singularText},${pluralText}`;

  return fetch(`${prefix}/wp-json/wp/v2/search?search=${singularText}&per_page=25&_embed`)
    .then(r => r.json())
    .then(results => {
      if (results.length === 0) {
        return fetch(`${prefix}/wp-json/wp/v2/search?search=${pluralText}&per_page=25&_embed`)
          .then(r => r.json());
      }
      return results;
    });
}

const fetchClassLists = async (ids) => {
  const url = `${prefix}/wp-json/search-results/v1/all-post-types?include=${ids.join(',')}`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

// Filter by specific class lists
const filterByClassList = (classList) => {
  const educationInsights = classList.includes("wb-tag-education-insights");
  const products = classList.includes("product-product");
  const documentTypes = classList.includes("document-type-document-type") &&
                        classList.includes("document-type-tools-calculators") &&
                        classList.includes("document-type-tools-calculators-online-banking");

  return {
    educationInsights,
    products,
    documentTypes,
  };
}

async function addAutoComplete(searchEl) {
  const searchForm = searchEl?.closest('form')

  if (!searchEl || !searchForm) {
    console.warn({ searchEl, parentForm: searchForm });
    return;
  }
  
  searchForm.style.position = 'relative';
  searchEl.setAttribute('autocomplete', 'off');
  searchEl.classList.add('autocomplete-input');

  const autoCompleteElement = document.createElement('div');
  autoCompleteElement.classList.add('autocomplete-taxonomy')
  searchForm.appendChild(autoCompleteElement)

  let searchVal = '';
  let canSearch = false;
  const fuseOptions = { keys: ["title"] };
  const fuse = new Fuse([], fuseOptions);

  const searchInterval = setInterval(() => {
    if (!canSearch) return;
    canSearch = false;
    searchWp(searchVal).then((d) => {
      //console.log("Search Results: ", d);
      fuse.setCollection(d);
      const search_results = fuse.search(searchVal);
      //console.log("Filtered search results: ", search_results);

      const ids = search_results.map(result => result.item.id);

      fetchClassLists(ids).then((classLists) => {
        //console.log("Fetched Class Lists: ", classLists);

        // Initialize category filters
        const resultsByTaxonomy = {
          educationInsights: [],
          products: [],
          documentTypes: [],
        };

        // Filter results based on class_list
        search_results.forEach((result) => {
          const postId = result.item.id;
          const classList = classLists.find(item => item[0] === `post-${postId}`) || [];  // Find class list based on post ID
          //console.log("Class List for Post ID " + postId + ": ", classList);

          const filters = filterByClassList(classList);
          //console.log("Filters for current result: ", filters);

          if (filters.educationInsights) resultsByTaxonomy.educationInsights.push(result);
          if (filters.products) resultsByTaxonomy.products.push(result);
          if (filters.documentTypes) resultsByTaxonomy.documentTypes.push(result);

          //console.log("resultsByTaxonomy.educationInsights: ", resultsByTaxonomy.educationInsights);
          //console.log("resultsByTaxonomy.products: ", resultsByTaxonomy.products);
          //console.log("resultsByTaxonomy.documentTypes: ", resultsByTaxonomy.documentTypes);
        });

        // Log filtered results for each taxonomy
        //console.log("Results by Taxonomy: ", resultsByTaxonomy);

        // Limit the results to top 3 for each taxonomy
        const topResultsByTaxonomy = {
          educationInsights: resultsByTaxonomy.educationInsights.slice(0, 3),
          products: resultsByTaxonomy.products.slice(0, 3),
          documentTypes: resultsByTaxonomy.documentTypes.slice(0, 3),
        };

        //console.log("Top Results by Taxonomy: ", topResultsByTaxonomy);

        updateSize();
        openAutoComplete({ topResultsByTaxonomy, searchVal });
      });
    });
  }, 700);

  const closeAutoComplete = () => {
    autoCompleteElement.dataset['open'] = false;
  }

  const updateSize = () => {
    const rect = searchForm.getBoundingClientRect();
    autoCompleteElement.style.width = `${rect.width + 10}px`;
    autoCompleteElement.style.top = `${rect.height + 5}px`;
    autoCompleteElement.style.left = `-5px`;
  }

  const openAutoComplete = ({ topResultsByTaxonomy, searchVal }) => {
    autoCompleteElement.dataset['open'] = true;
    const searchWords = searchVal.split(' ').filter(l => l.length > 0);
    let view = '';

    Object.entries(topResultsByTaxonomy).forEach(([taxonomyKey, resultList]) => {
      if (resultList.length === 0) return;

      let taxName = '';
      switch (taxonomyKey) {
        case 'educationInsights':
          taxName = 'Education & Insights';
          break;
        case 'products':
          taxName = 'Products';
          break;
        case 'documentTypes':
          taxName = 'Tools &amp Calculators';
          break;
        default:
          taxName = taxonomyKey;
      }

      const sectionMarkup = `
        <div data-name="${taxonomyKey}">
          <div class="autocomplete-section-title">${taxName}</div>
          <ul class="autocomplete">
            ${resultList.map(result => `
              <li>
                <a href="${result.item.url}" title="${result.item.title}">
                  ${result.item.title}
                </a>
              </li>`).join('')}
          </ul>
        </div>
      `;
      view += sectionMarkup;
    });

    if (view) {
      autoCompleteElement.innerHTML = view;
      requestAnimationFrame(() => {
        autoCompleteElement.querySelectorAll('a').forEach(anchor => {
          anchor.innerHTML = replaceWordsWithSpan(anchor.innerHTML, searchWords);
        });
      });
    } else {
      autoCompleteElement.innerHTML = `<div class="no-results">
        <div>No results found for <b>${searchVal}</b></div>
        <div>
          <ul>
            <li><a href="/education-insights/">Education and Insights</a></li>
            <li><a href="/education-insights/banking-tools-and-calculators/">Tools and Calculators</a></li>
            <li><a href="/education-insights/">Products</a></li>
          </ul>
        </div>
      </div>`;
    }
  }

  searchEl.addEventListener('input', debounce(function(inputEvent) {
    canSearch = searchEl.value.length > 0 && searchVal !== searchEl.value;
    searchVal = searchEl.value;
    if (searchVal.length === 0) {
      closeAutoComplete();
    }
  }, 300));

  window.addEventListener('resize', () => {
    updateSize();
  });

  return {
    closeAutoComplete,
    openAutoComplete,
    updateSize,
  }
}

export default {
  addAutoComplete,
  searchWp,
}
